import { Design } from '@//model/document2/page/surface/design/design';
import { Document } from '@/model/document2/document';

import { StringHelper } from './stringHelper';

// 命名ヘルパークラス
export class NameHelper
{
    // 数字の最大
    static readonly MAX_NUMBER = 10000;

    // 新規ドキュメントファイル名を生成する
    public static createNewDocumentFileName(document : Document)
    {
        // 日付
        var date = new Date();
        
        // YYYYMMDD-用紙番号 とする
        var fileName = StringHelper.zeroPadding(date.getFullYear(), 4) + 
            StringHelper.zeroPadding(date.getMonth() + 1, 2) +
            StringHelper.zeroPadding(date.getDate(), 2) + 
            "-" +
            document.paperCode;
        
        return fileName;
    }

    // レイヤー名を生成する
    // type... 名称種別
    // "plaintext" : 通常文字_1
    // "circletext" : 円周文字_1
    // "3dtext" : 3D文字_1
    // "datetext" : 日付文字_1
    // "image" : 画像_1
    // "rectangle" : 四角形_1
    // "circle" : 円_1
    // "polygon" : 多角形_1
    // "line" : 直線_1
    // "curve" : 曲線_1
    // "barcode" : バーコード_1
    // "qrcode" : QRコード_1
    // "table" : 表_1
    // "calendar" : カレンダー_1
    // "number" : 連番_1
    // "group" : グループ_1
    public static createLayerName(type : string, design : Design)
    {
        var layername = "オブジェクト";
        
        if(type == "plaintext") { layername = "特殊文字"; }
        else if(type == "circletext") { layername = "円周文字"; }
        else if(type == "3dtext") { layername = "3D文字"; }
        else if(type == "datetext") { layername = "日付文字"; }
        else if(type == "image") { layername = "画像"; }
        else if(type == "rectangle") { layername = "四角形"; }
        else if(type == "circle") { layername = "円"; }
        else if(type == "polygon") { layername = "多角形"; }
        else if(type == "line") { layername = "直線"; }
        else if(type == "curve") { layername = "曲線"; }
        else if(type == "barcode") { layername = "バーコード"; }
        else if(type == "qrcode") { layername = "QRコード"; }
        else if(type == "table") { layername = "表"; }
        else if(type == "number") { layername = "連番"; }
        else if(type == "group") { layername = "グループ"; }
        else if(type == "uTurn") { layername = "Uターン矢印"; }
        else if(type == "cross") { layername = "十字形"; }
        else if(type == "heart") { layername = "ハート"; }
        else if(type == "cloud") { layername = "雲"; }
        else if(type == "explosion") { layername = "爆発"; }
        else if(type == "rectangleBalloon") { layername = "四角形吹き出し"; }
        else if(type == "roundedRectangleBalloon") { layername = "角丸四角形吹き出し"; }
        else if(type == "circleBalloon") { layername = "円形吹き出し"; }
        else if(type == "calendar") { layername = "カレンダー"; }
        else if(type == "simpleText") { layername = "通常文字"; }
        
        layername += "_";

        // 数字を1から回す。
        for(var num = 1; num <= this.MAX_NUMBER; ++num)
        {
            var newname = layername + String(num);
            if(num == this.MAX_NUMBER)
            {
                // 最大番号まで到達したのでこれで決定する
                layername = newname;
                break;
            }

            // この名前が存在するか調べる
            var isExisted = false;
            for(var layer of design.getAllLayers(true))
            {
                if(layer.name == newname)
                {
                    // 同じ名前がある
                    isExisted = true;
                    break;
                }
            }

            if(!isExisted)
            {
                // 同じ名前がない場合はこの名前で決定する
                layername = newname;
                break;
            }
        }

        return layername;
    }
}